import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M22 15c1.11 0 2.012.902 2.012 2.012a2.013 2.013 0 0 1-2.011 2.008 2.013 2.013 0 0 1-2.012-2.008c0-1.11.902-2.012 2.012-2.012Zm0 7.008a4.998 4.998 0 0 0 0-9.996c-2.757 0-5 2.242-5 5a5.004 5.004 0 0 0 5 4.996Zm1.965 3.82a8.975 8.975 0 0 0 2.82-1.168 1.423 1.423 0 0 0-1.515-2.406 6.17 6.17 0 0 1-6.539 0 1.423 1.423 0 1 0-1.516 2.406 8.938 8.938 0 0 0 2.82 1.168l-2.718 2.719a1.42 1.42 0 0 0 .004 2.012 1.417 1.417 0 0 0 2.012 0L22 27.89l2.671 2.668a1.424 1.424 0 0 0 2.012 0 1.424 1.424 0 0 0 0-2.012l-2.719-2.719Z"
    }, null, -1)
  ])))
}
export default { render: render }